import { useEffect, useState } from "react";

import { KeyboardShortcut } from "@/components";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

export const AddEnrichmentContextDialog = ({
  description,
  initialValue,
  onOpenChange,
  onSave,
  open,
  placeholder,
  saveButtonText,
  title,
}: {
  description: string;
  initialValue: string;
  onOpenChange: (open: boolean) => void;
  onSave: (value: string) => void;
  open: boolean;
  placeholder: string;
  saveButtonText: string;
  title: string;
}) => {
  /* React Hooks */
  // useState
  const [draft, setDraft] = useState(initialValue);

  // useEffect — reset draft to initialValue each time the dialog opens.
  useEffect(() => {
    if (open) setDraft(initialValue);
  }, [initialValue, open]);

  /* Handlers */
  const handleSave = () => {
    onSave(draft.trim());
    onOpenChange(false);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  /* Render */
  const render = () => {
    return (
      <Dialog onOpenChange={onOpenChange} open={open}>
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>{description}</DialogDescription>
          </DialogHeader>
          <Textarea
            className="min-h-[200px] resize-y"
            onChange={(e) => {
              setDraft(e.target.value);
            }}
            onKeyDown={(e) => {
              if ((e.metaKey || e.ctrlKey) && e.key === "Enter") {
                e.preventDefault();
                if (draft.trim()) handleSave();
              }
            }}
            placeholder={placeholder}
            value={draft}
          />
          <DialogFooter>
            <Button
              className="rounded-full"
              onClick={handleCancel}
              type="button"
              variant="outlineSecondary"
            >
              Cancel
            </Button>
            <Button
              className="rounded-full"
              disabled={!draft.trim()}
              onClick={handleSave}
              type="button"
            >
              {saveButtonText}
              <KeyboardShortcut text="⌘↵" variant="primary" />
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  };

  return render();
};
